export const Leaderboard = [
	{ nickname: "Jean Valjean", score: 24601 },
	{ nickname: "Vegeta", score: 9000 },
	{ nickname: "Rush", score: 2112 },
	{ nickname: "Beelzebub", score: 666 },
	{ nickname: "Stitch", score: 626 },
	{ nickname: "Master Chief", score: 117 },
	{ nickname: "Soldier: 76", score: 76 },
	{ nickname: "Arthur Dent", score: 42 },
	{ nickname: "Archimedes", score: 3.14159 },
	{ nickname: "One-Punch Man", score: 1 },
]
